import { Injectable } from '@angular/core';
import { Campaign } from './campaign.model';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CampaignService {
    private campaignsUrl = 'api/campaigns';

    private notify = new Subject<any>();

    public campaigns: Campaign[];

    /**
     * Observable string streams
     */
    notifyObservable$ = this.notify.asObservable();

    constructor(private http: Http) { }

    public notifyOther(data: any) {
        if (data) {
            this.notify.next(data);
        }
    }
    loadCampaigns(): Promise<Campaign[]> {
        return this.http.get(this.campaignsUrl).toPromise().then(res => {
            return this.campaigns = res.json();
        });
    };

    getCampaignYears(): string[] {
        return Object.keys(this.campaigns).sort((y1, y2) => (y1 > y2) ? -1 : 1);
    }

    getCurrentCampaign(): Campaign {
        return this.campaigns[this.getCurrentCampaignYear()];
    }
    getCurrentCampaignYear(): string {
        return Object.keys(this.campaigns).find(k => this.campaigns[k].currentCampaign);
    }
    getNextCampaignYear(): string {
        return (Number(this.getCurrentCampaignYear()) + 1).toString();
    }
    getNextOpenCampaignYear(): string {
        let result = this.getCurrentCampaignYear();
        if (!this.isCurrentCampaignOpen()) {
            result = this.getNextCampaignYear();
        }
        return result;
    }
    getLicenceOldestYear(): string {
        return (Number(this.getCurrentCampaignYear()) - 2).toString();
    }



    isCurrentCampaignOpen(): boolean {
        return this.campaigns[this.getCurrentCampaignYear()].campaignOpen;
    }
    isUserViewingCurrentCampaign(): boolean {
        return this.getDisplayedCampaign() === this.getCurrentCampaignYear();
    }
    isUserViewingCurrentOrFutureCampaign(): boolean {
        return +this.getDisplayedCampaign() >= +this.getCurrentCampaignYear();
    }
    isUserViewingCurrentOrPreviousCampaign(): boolean {
        return +this.getDisplayedCampaign() <= +this.getCurrentCampaignYear();
    }
    isObjectFromCurrentCampaign(campaign: string): boolean {
        return this.getCurrentCampaignYear() === campaign;
    }




    setDisplayedCampaign(campaign: string): void {
        sessionStorage.setItem('campaign', campaign);
    }

    getDisplayedCampaign(): string {
        if (!sessionStorage.getItem('campaign')) {
            this.setDisplayedCampaign(this.getCurrentCampaignYear());
        }
        return sessionStorage.getItem('campaign');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campaign/campaign.service.ts